import { Badge, Spinner, Tag } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type SaveStatus = "idle" | "pending" | "saving" | "saved" | "error";

export const SaveStatusBadge = ({ status, variant = "badge" }: { status: SaveStatus; variant?: "badge" | "tag" }) => {
  const { t } = useTranslation();
  if (status === "saving" || status === "pending") {
    return (
      <StatusMark variant={variant} colorScheme="gray">
        <Spinner size="xs" />
        {t("Saving…")}
      </StatusMark>
    );
  }
  if (status === "saved") {
    return (
      <StatusMark variant={variant} colorScheme="gray">
        {t("Saved")}
      </StatusMark>
    );
  }
  if (status === "error") {
    return (
      <StatusMark variant={variant} colorScheme="red">
        {t("Could not save")}
      </StatusMark>
    );
  }
  return null;
};

const StatusMark = ({
  variant,
  colorScheme,
  children,
}: {
  variant: "badge" | "tag";
  colorScheme: "gray" | "red";
  children: ReactNode;
}) =>
  variant === "tag" ? (
    <Tag variant="outline" colorScheme={colorScheme} display="inline-flex" alignItems="center" gap="1">
      {children}
    </Tag>
  ) : (
    <Badge colorScheme={colorScheme} fontWeight="normal" display="inline-flex" alignItems="center" gap="1">
      {children}
    </Badge>
  );
